import "../styles/Recommendations.css"

function FeedingGuidelines({ guidelines }) {
  return (
    <div className="feeding-guidelines-section">
      <h2 className="section-title">📏 Feeding Tips:</h2>
      <div className="guidelines-content">
        {Array.isArray(guidelines) ? (
          <ul className="guidelines-list">
            {guidelines.map((guideline, index) => (
              <li key={index}>{guideline}</li>
            ))}
          </ul>
        ) : (
          <p>{guidelines}</p>
        )}
      </div>
    </div>
  )
}

export default FeedingGuidelines

